import React from 'react';

import { PrismicRichText } from 'types/prismicRichtext';
import { RichText } from 'components/rich-text/RichText';
import { Quote } from 'components/quote/Quote';

interface IQuoteContainer {
  quote: PrismicRichText;
  citation: PrismicRichText;
  isColumnLayout?: boolean;
}

export const QuoteContainer = ({ quote, citation, isColumnLayout }: IQuoteContainer) => {
  return (
    <Quote
      quote={<RichText>{quote}</RichText>}
      citation={citation ? <RichText>{citation}</RichText> : undefined}
      isColumnLayout={isColumnLayout}
    />
  );
};
